var map = {
	"./android.png": 3421,
	"./apple.png": 3422,
	"./back-activation.png": 2047,
	"./back-activation@2x.png": 2048,
	"./back-block-2.png": 3423,
	"./back-block-2@2x.png": 3424,
	"./back.png": 2880,
	"./back@2x.png": 2881,
	"./block-mobile-1.png": 2882,
	"./block-mobile-1@2x.png": 2883,
	"./block-mobile-2.png": 2884,
	"./block-mobile-2@2x.png": 2885,
	"./bonus-info.png": 2049,
	"./bonus-info@2x.png": 2886,
	"./bonus-info_mobile.png": 2050,
	"./bonus-info_mobile@2x.png": 2887,
	"./card-back.png": 2888,
	"./card-back@2x.png": 3425,
	"./card.png": 3426,
	"./card2.png": 2889,
	"./card2@2x.png": 2890,
	"./code.png": 3427,
	"./coin.png": 2891,
	"./coin@2x.png": 2892,
	"./coins.png": 2893,
	"./coins@2x.png": 2894,
	"./ellipse-blue.png": 2895,
	"./ellipse-blue@2x.png": 2896,
	"./ellipse-yellow.png": 2897,
	"./ellipse-yellow@2x.png": 2898,
	"./gift.png": 3428,
	"./gift@2x.png": 3429,
	"./phone-mobile-2.png": 2899,
	"./phone-mobile-2@2x.png": 2900,
	"./phone-mobile.png": 2901,
	"./phone-mobile@2x.png": 2902,
	"./phone.png": 2903,
	"./phone@2x.png": 2904,
	"./qr-code.png": 2905,
	"./stars-bottom.png": 2906,
	"./stars-bottom2x.png": 3430,
	"./stars-mobile.png": 2907,
	"./stars-mobile@2x.png": 2908,
	"./wallet.png": 2909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3420;